import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import * as GovernanceApi from '../../../API/GovernenceAPI'
import { immer } from 'zustand/middleware/immer'
import * as OnboardingAPI from '../../../API/OnboardingAPI'
import * as CommonAPI from '../../../API/CommonAPI'

const initialState = {
    allregulations: [],
    selectedRegData: [],
    governanceLoading: false,
    getOrgRegulationData: [],
    orgRegulationError: '',
    selectedRegulations: [],
    selectedRegulationsError: '',
    managementData: [],
    managementDataError: false,
    allRegulationsError: ' ',
    allDepartments: [],
    allDepartmentsError: false,
    allRoles: [],
    allRolesError: false,
    allUsers: [],
    allUsersError: false,
    raciMatrixOptions: {
        responsible: { },
        accountable: { },
        consulted: { },
        informed: { }
    },
    featNavigationData: [],
    governanceLoading2: false
}
const GovernanceStore = (set, get) => ({
    ...initialState,
    govLoadOverRide: (value) => {
        set({ governanceLoading2: value })
    },
    govLoadOn: () => {
        set({ governanceLoading: true })
    },
    govLoadOff: () => {
        set({ governanceLoading: false })
    },
    storeRegData: (data) => {
        set({ selectedRegData: data })
    },
    addOrgRegulation: async (data, orgId, loginId) => {
        set({ governanceLoading: true })
        try {
            const response = await GovernanceApi.addOrgRegulation(data, orgId, loginId)
            if (response.data) {
                set({ governanceLoading: false })
            } else {
                set({ governanceLoading: false })
            }
        } catch (error) {
            set({ allRegulationsError: error, governanceLoading: false })
        }
    },
    selectOrgRegulation: async (data, orgId, loginId) => {
        set({ governanceLoading: true })
        try {
            await GovernanceApi.selectOrgRegulation(data, orgId, loginId)
            set({ governanceLoading: false })
        } catch (error) {
            set({ allRegulationsError: error, governanceLoading: false })
        }
    },
    getOrgRegulation: async (orgId, loginId, typeId) => {
        set((state) => ({ ...state, governanceLoading: true }))
        try {
            const response = await OnboardingAPI.getOrgRegulation(orgId, loginId, typeId)
            set((state) => ({ ...state, governanceLoading: false, getOrgRegulationData: response.data || [] }))
        } catch (error) {
            set((state) => ({ ...state, orgRegulationError: error.message || 'An error occurred', governanceLoading: false }))
        }
    },
    getAllRegulations: async () => {
        try {
            set({ governanceLoading: true })
            const response = await GovernanceApi.getAllRegulations()
            if (response.data) {
                set({ allregulations: response.data, governanceLoading: false })
            } else {
                set({ allRegulationsError: false, allregulations: initialState.allregulations, governanceLoading: false })
            }
        } catch (error) {
            set({ allRegulationsError: error, governanceLoading: false })
        }
    },
    getAllRegulationsBasedType: async (bodyType) => {
        try {
            set({ governanceLoading: true })
            const response = await GovernanceApi.getAllRegulationsBasedType(bodyType)
            if (response.data) {
                set({ allregulations: response.data, governanceLoading: false })
            } else {
                set({ allRegulationsError: false, allregulations: initialState.allregulations, governanceLoading: false })
            }
        } catch (error) {
            set({ allRegulationsError: error, governanceLoading: false })
        }
    },
    getSelectedRegulations: async (orgId, typeId) => {
        set({ governanceLoading: true })
        try {
            const response = await GovernanceApi.getSelectedRegulations(orgId, typeId)
            set({ governanceLoading: false, selectedRegulations: response.data })
            return response.data
        } catch (error) {
            set({ selectedRegulationsError: error, governanceLoading: false })
        }
    },
    getDepOrganizations: async (organizationId) => {
        try {
            const response = await GovernanceApi.getDepOrg(organizationId)
            if (response.data) {
                set({ allDepartments: response.data })
            } else {
                set({ allDepartmentsError: false, allDepartments: initialState.allDepartments })
            }
        } catch (error) {
            set({ allDepartmentsError: error, governanceLoading: false })
        }
    },
    getRoleByDepartment: async (departmentId) => {
        try {
            const response = await GovernanceApi.getRolebyDep(departmentId)
            if (response.data) {
                set({ allRoles: response.data })
            } else {
                set({ allRolesError: false, allRoles: initialState.allRoles })
            }
        } catch (error) {
            set({ allRolesError: error, governanceLoading: false })
        }
    },
    getUserByRole: async (roleId) => {
        try {
            const response = await GovernanceApi.getUserByRole(roleId)
            if (response.data) {
                set({ allUsers: response.data })
            } else {
                set({ allUsersError: false, allUsers: initialState.allUsers })
            }
        } catch (error) {
            set({ allUsersError: error, governanceLoading: false })
        }
    },
    getManagementTeam: async (orgId) => {
        try {
            const response = await GovernanceApi.getManagementTeam(orgId)
            if (response.data) {
                set({ managementData: response.data })
            } else {
                set({ managementDataError: false, managementData: initialState.allUsers })
            }
        } catch (error) {
            set({ allUsersError: error, governanceLoading: false })
        }
    },
    updateRaciOptions: (data) => {
        set({ raciMatrixOptions: data })
    },
    getFeatureNavigationMenu: async (userId, orgId) => {
        try {
            const response = await CommonAPI.featureNavigationMenu(userId, orgId)
            if (response.data) {
                set({ featNavigationData: response.data })
            }
        } catch (error) {
        }
    }
})

export const useGovernanceStore = create(devtools(immer(GovernanceStore)))
